export default {
  height: 'auto',
  calcHeight: 30,
  tip: false,
  searchShow: true,
  searchMenuSpan: 8,
  span:8,
  searchSpan: 8,
  border: true,
  index: true,
  selection: true,
  viewBtn: true,
  dialogClickModal: false,
  searchMenuPosition: 'right',
  column: [
    {
      label: "参数名称",
      prop: "paramName",
      search: true,
      maxlength:200,
      rules: [{
        required: true,
        message: "请输入参数名称",
        trigger: "blur"
      }]
    },
    {
      label: "参数键名",
      prop: "paramKey",
      search: true,
      maxlength:200,
      rules: [{
        required: true,
        message: "请输入参数键名",
        trigger: "blur"
      }]
    },
    {
      label: "参数键值",
      prop: "paramValue",
      maxlength:200,
      rules: [{
        required: true,
        message: "请输入参数键值",
        trigger: "blur"
      }]
    }
  ]
};
